import type { Href } from "expo-router";
import type { ReactNode } from "react";
import { View } from "react-native";
import { Button } from "~/components/Button";
import { BodyText, Title } from "~/components/layout/text";
import type { QendoIconSet } from "~/components/QendoIcon";
import { Gap, Items, Width } from "~/constants/layout";
import { HomeIcon } from "./HomeIcon";

type HomeCardProps = {
    title: string;
    icon: QendoIconSet;
    subtitle: string;
    children?: ReactNode;
    href?: Href;
    linkText?: string;
};

export const HomeCard = ({ title, subtitle, icon, children, href, linkText = "" }: HomeCardProps) => {
    return (
        <View style={[Items.start, Gap.lg, Width.full]}>
            <HomeIcon icon={icon} />
            <Title size="xl">{title}</Title>
            <BodyText>{subtitle}</BodyText>
            {children}
            {href && <Button href={href} size="lg" variant="secondary" title={linkText} style={Width.full} />}
        </View>
    );
};
